/**
 * Get excise duty reports header needed for month year selection component
 */

import { getToken } from "../utils";
import { BASE_URL } from "../endpoints";

const getReportsHeaders = async () => {
  const token = getToken();
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/metadata/report_headers`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data.duty_reports;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token or not admin
  }
};

export default getReportsHeaders;
